import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef61092a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "subject-header" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "intro"
}
const _hoisted_4 = { class: "course-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_Card = _resolveComponent("Card")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_a_spin, {
      tip: "加载中...",
      spinning: _ctx.loading
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["subject-detail", _ctx.theme])
        }, [
          _createVNode(_component_a_breadcrumb, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumb, (item) => {
                return (_openBlock(), _createBlock(_component_a_breadcrumb_item, {
                  key: item.title
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.subjectName), 1),
            (_ctx.subjectIntro)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.subjectIntro), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Card, {
              gutter: 22,
              span: 6,
              courses: _ctx.courseList,
              onJumpToCourse: _ctx.jumpToCourse
            }, null, 8, ["courses", "onJumpToCourse"])
          ])
        ], 2)
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}